/**
 * RespawnCountdown — HUD element (extracted from PixiHUDRenderer.js in Phase 3D).
 *
 * create(hud) builds the PIXI objects into hud.elements.respawnCountdown,
 * position(hud) lays them out for hud.screenWidth/Height, update(hud, …) redraws
 * from game state. `hud` is the PixiHUDRenderer coordinator: it owns
 * hudContainer, elements, screen size, _createText() and send().
 */
import * as PIXI from 'pixi.js';

export function create(hud) {
  const container = new PIXI.Container();
  container.visible = false;
  hud.hudContainer.addChild(container);

  const countdownText = new PIXI.Text({
    text: '',
    style: {
      fontFamily: 'Arial',
      fontSize: 36,
      fontWeight: 'bold',
      fill: 0xffffff,
      stroke: { color: 0x000000, width: 2 }
    }
  });
  countdownText.anchor.set(0.5, 0.5);
  container.addChild(countdownText);

  hud.elements.respawnCountdown = { container, countdownText };
}

export function update(hud, localPlayer) {
  const rc = hud.elements.respawnCountdown;
  if (!rc) return;

  if (!localPlayer || !localPlayer.isDead || !localPlayer.respawnScheduledAt) {
    rc.container.visible = false;
    return;
  }

  const now = performance.now();
  const elapsed = now - localPlayer.respawnScheduledAt;
  const remaining = Math.max(0, localPlayer.respawnDelay - elapsed);
  const secondsRemaining = Math.ceil(remaining / 1000);

  if (secondsRemaining <= 0) {
    rc.container.visible = false;
    return;
  }

  rc.container.visible = true;
  rc.countdownText.text = `Respawning in ${secondsRemaining}...`;

  // Center on screen, positioned above death notification
  rc.container.x = hud.screenWidth / 2;
  rc.container.y = hud.screenHeight / 2 - 150;
}
